import type { RootState } from "rdx/types";
import type { Contract, ContractDetailsStateT } from "./types/contracts";

export const getContractDetails = (state: RootState): ContractDetailsStateT => state.projects.contractDetails;

export const getContractById =
  (id: number | null | undefined) =>
  (state: RootState): Contract | undefined =>
    getContractDetails(state).contracts?.find((c) => c.contractId === id);
